<template>
  <div class="calculation p-4">
    <template v-if="loaded">
      <p class="has-text-weight-bold is-size-6">
        {{ $t("mp:new_application.calculation.title") }}
      </p>
      <div class="data is-flex is-flex-direction-column">
        <div
          class="is-flex is-flex-direction-row is-justify-content-space-between"
        >
          <p class="m-0 p-0">{{ $t("mp:new_application.calculation.apr") }}</p>
          <p class="m-0 p-0 has-text-weight-bold">{{ calculation.thm }}%</p>
        </div>
        <div
          v-if="calculation.fee"
          class="is-flex is-flex-direction-row is-justify-content-space-between"
        >
          <p class="m-0 p-0">
            {{ $t("mp:new_application.calculation.serviceFee") }}
          </p>
          <p class="m-0 p-0 has-text-weight-bold">
            {{
              localizedFormatter(country.languageIso).money(
                calculation.currencyIso,
                calculation.fee
              )
            }}
          </p>
        </div>
        <div
          v-if="calculation.fee"
          class="is-flex is-flex-direction-row is-justify-content-space-between"
        >
          <p class="m-0 p-0">
            {{ $t("mp:new_application.calculation.service_fee_sum") }}
          </p>
          <p class="m-0 p-0 has-text-weight-bold">
            {{
              localizedFormatter(country.languageIso).money(
                calculation.currencyIso,
                calculation.fee * installmentCount
              )
            }}
          </p>
        </div>
        <div
          class="is-flex is-flex-direction-row is-justify-content-space-between"
        >
          <p class="m-0 p-0">
            {{ $t("mp:new_application.calculation.installment_count") }}
          </p>
          <p class="m-0 p-0 has-text-weight-bold">
            {{ installmentCount }}
            {{ $t("mp:in_store.calculation.installment_count") }}
          </p>
        </div>
        <div
          v-if="calculation.downPayment"
          class="is-flex is-flex-direction-row is-justify-content-space-between"
        >
          <p class="m-0 p-0">
            {{ $t("mp:new_application.calculation.down_payment") }}
          </p>
          <p class="m-0 p-0 has-text-weight-bold">
            {{
              localizedFormatter(country.languageIso).money(
                calculation.currencyIso,
                calculation.payments[0].sum
              )
            }}
          </p>
        </div>
        <div
          class="is-flex is-flex-direction-row is-justify-content-space-between"
        >
          <p class="m-0 p-0">
            {{ $t("mp:new_application.calculation.payment_sum") }}
          </p>
          <p class="m-0 p-0 has-text-weight-bold">
            {{
              localizedFormatter(country.languageIso).money(
                calculation.currencyIso,
                calculation.payments[calculation.payments.length - 1].sum
              )
            }}
          </p>
        </div>
        <div
          class="is-flex is-flex-direction-row is-justify-content-space-between"
        >
          <p class="m-0 p-0">{{ $t("mp:new_application.calculation.sum") }}</p>
          <p class="m-0 p-0 has-text-weight-bold">
            {{
              localizedFormatter(country.languageIso).money(
                calculation.currencyIso,
                calculation.total
              )
            }}
          </p>
        </div>
      </div>
      <hr class="has-background-grey-lighter" />
      <div class="payments-list">
        <div v-for="payment in calculation.payments" :key="payment.seq">
          <div class="payment">
            <div class="doughnut-chart">
              <DoughnutChart :seq="payment.seq" :max-seq="installmentCount" />
            </div>
            <div>
              <p class="has-text-weight-bold is-size-5 my-1">
                {{
                  localizedFormatter(country.languageIso).money(
                    calculation.currencyIso,
                    payment.sum
                  )
                }}
              </p>
              <p class="my-1">{{ daysRemaining(payment.dueDate) }}</p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <LoadingSkeleton v-else />
  </div>
</template>
<script>
import LoadingSkeleton from "@/components/LoadingSkeleton";
import DoughnutChart from "./DoughnutChart.vue";
import { localizedFormatter } from "../utils/util";
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  name: "Calculation",
  components: { LoadingSkeleton, DoughnutChart },
  computed: {
    ...mapGetters({
      country: "i18n/country",
    }),
    calculation() {
      return this.$store.getters["calculation/getCalculation"];
    },
    installmentCount() {
      if (this.calculation.downPayment !== 0) {
        return this.calculation.payments.length - 1;
      }
      return this.calculation.payments.length;
    },
    loaded() {
      return !this.$store.getters["calculation/getLoading"];
    },
  },
  methods: {
    localizedFormatter,
    daysRemaining(date) {
      let difference = new Date(date).getTime() - Date.now();
      let totalDays = Math.ceil(difference / (1000 * 3600 * 24));
      if (totalDays === 0) {
        return this.$i18n.t("mp:new_application.calculation.payment_now");
      }
      return `${totalDays} ${this.$i18n.t(
        "mp:new_application.calculation.payment_days"
      )}`;
    },
    getMoneyFormat(value) {
      const numberFormat = new Intl.NumberFormat("hu-HU", {
        style: "currency",
        currency: "HUF",
        maximumFractionDigits: 0,
      });
      return numberFormat.format(value);
    },
  },
};
</script>
<style scoped lang="scss">
.calculation {
  background: #f5f7fb;
  border-radius: 16px;
  margin-top: 16px;
}

.data {
  gap: 16px;
}

.payments-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  & > div {
    flex: 0 0 50%;
  }
  .doughnut-chart {
    width: 35px;
    margin-right: 16px;
  }

  .payment {
    display: flex;
    flex-direction: row;
    background: white;
    border-radius: 8px;
    box-sizing: border-box;
    margin: 16px;
    padding: 16px;
  }
}
</style>
